import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';

import Lozenge from '@atlaskit/lozenge';

const i18n = defineMessages({
	new: {
		id: 'live-pages-features.new.lozenge',
		defaultMessage: 'New',
		description: 'Text for the new lozenge. Informs users that the associated feature is new.',
	},
});

type LivePagesBetaLozengeProps = {
	bold?: boolean;
};

export const LivePagesBetaLozenge = ({ bold = false }: LivePagesBetaLozengeProps) => (
	<Lozenge appearance="new" isBold={bold}>
		<FormattedMessage {...i18n.new} />
	</Lozenge>
);
